// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .swiper {
  width: 100%;
} */
.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  text-align: center;
  height: 500px;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/sitelet/input-page/files-card/carousel/index.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":["/* .swiper {\n  width: 100%;\n} */\n.swiper-slide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  text-align: center;\n  height: 500px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
